module.exports = __webpack_public_path__ + "img/check_simple_two.588232a2.svg";